import { render, staticRenderFns } from "./SwitchNew.htm?vue&type=template&id=384bc203&scoped=true&"
import script from "./SwitchNew.js?vue&type=script&lang=js&"
export * from "./SwitchNew.js?vue&type=script&lang=js&"
import style0 from "./SwitchNew.scss?vue&type=style&index=0&id=384bc203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384bc203",
  null
  
)

export default component.exports